import { render, staticRenderFns } from "./carinoutinfo.vue?vue&type=template&id=54d67a5a&"
import script from "./carinoutinfo.vue?vue&type=script&lang=js&"
export * from "./carinoutinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports